export const totalSortDirections: any = ['descend', 'ascend'];

export default function sortByTotal(a, b) {
  return a.total - b.total;
}
